import { render, staticRenderFns } from "./TicketAndHotelEmptyCard.vue?vue&type=template&id=48fb5472&"
import script from "./TicketAndHotelEmptyCard.vue?vue&type=script&lang=js&"
export * from "./TicketAndHotelEmptyCard.vue?vue&type=script&lang=js&"
import style0 from "./TicketAndHotelEmptyCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports